import React, { useEffect } from 'react';
import {
  LearningInfo,
  ListModuleContentsData,
} from '@/api/seller/serv/oec_seller_learning_center_api';
import { useHistory } from 'react-router-dom';
import bg from '@/assets/imgs/module-list/background.png';
// import styles from '@/components/article-container/index.scss';
// import { PagePathV2 } from '@/types/index';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';
// import { useHistory } from 'react-router-dom';
import WebinarCard from '@/components/webinar-card';

import {
  reportContentClick_webinar,
  reportContentExposure_webinar,
  reportPageDuration_webinar,
} from './index.Report';
import Select from '@m4b-design/select';
import { PagePathV2 } from '@/types';
import { changeQuery } from '@/libs/url';

export interface ConfigurationLandingPageProps {
  moduleData?: ListModuleContentsData;
}

export const WebinarModuleLandingPage: React.FC<
  ConfigurationLandingPageProps
> = props => {
  const [renderList, setRenderList] = React.useState<
    LearningInfo[] | undefined
  >();
  const [sortMethod, setSortMethod] = React.useState<string>('newest');
  const { t } = useTranslation();
  const history = useHistory();

  const { moduleData } = props;
  const panelTitle = moduleData?.module_content_name;

  useEffect(() => {
    const webinarList = moduleData?.learning_info
      ?.filter(item => Number(item?.learning_id) !== 0)
      .sort((a, b) => {
        if (sortMethod === 'newest') {
          return Number(b?.create_time) - Number(a?.create_time);
        } else if (sortMethod === 'oldest') {
          return Number(a?.create_time) - Number(b?.create_time);
        } else if (sortMethod === 'most') {
          return Number(b?.views) - Number(a?.views);
        } else if (sortMethod === 'lease') {
          return Number(a?.views) - Number(b?.views);
        }
        return 0;
      });
    setRenderList(webinarList);
  }, [moduleData, sortMethod]);

  const handleSortChange = (value: string) => {
    reportContentClick_webinar(
      'academy_webinar_portal_prev',
      `prev_webinar_sort_${value}`,
    );
    setSortMethod(value);
  };

  const jumpToCourse = (learningId: number | undefined, index: number) => {
    reportContentClick_webinar(
      'academy_webinar_portal_prev',
      'webinar_video',
      String(learningId),
      String(index),
    );
    if (learningId) {
      history.push({
        pathname: PagePathV2.CourseDetail,
        search: changeQuery({
          learning_id: String(learningId),
          from: 'modules',
        }),
      });
    }
  };

  const options = [
    {
      label: t('academy_webinar_sort_newest'),
      value: 'newest',
    },
    {
      label: t('academy_webinar_sort_oldest'),
      value: 'oldest',
    },
    {
      label: t('academy_webinar_sort_most'),
      value: 'most',
    },
    {
      label: t('academy_webinar_sort_least'),
      value: 'lease',
    },
  ];

  useEffect(() => {
    const startTime = Date.now();
    reportContentExposure_webinar('academy_webinar_portal_prev');

    const handlePageDuration = () => {
      reportPageDuration_webinar(Date.now() - startTime);
    };

    window.addEventListener('beforeunload', handlePageDuration);
    return () => {
      handlePageDuration();
      window.removeEventListener('beforeunload', handlePageDuration);
    };
  }, []);

  return (
    <>
      <section
        className="w-[100%] h-[269px] flex justify-center items-center flex-col"
        style={{ background: `URL(${bg})` }}>
        <div className="text-[40px] font-bold leading-none">
          {t('academy_webinar_header')}
        </div>
        <div className="text-[16px] max-w-[800px] text-center font-normal leading-[24px] text-black/55">
          {t('academy_webinar_description')}
        </div>
      </section>
      <section className="mx-auto bg-neutral-white pb-16 rounded-8">
        <section className="mx-auto w-[1280px] pt-40 rounded-8">
          <div className="w-[100%] flex justify-between items-center mb-24">
            <p className="text-[28px] text-black-0 leading-[36px] font-bold">
              {t('academy_webinar_past_section') || panelTitle}
            </p>
            <div>
              <Select
                defaultActiveFirstOption={true}
                value={sortMethod}
                style={{ width: 180 }}
                onChange={handleSortChange}>
                {options.map((option, index) => (
                  <Select.Option key={index} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
          <div className="grid grid-cols-4 gap-x-[13px] gap-y-[32px]">
            {renderList?.map((item, index) => {
              return (
                <WebinarCard
                  key={index}
                  id={item.learning_id}
                  image={item.image || ''}
                  name={item.name}
                  createTime={item.create_time || 0}
                  views={item.views}
                  onClick={() => {
                    jumpToCourse(item.learning_id, index);
                  }}
                />
              );
            })}
          </div>
        </section>
      </section>
    </>
  );
};
